function FiFeatureCarouselCard({ tool, checkIconAlt }) {
  return (
    <div className="fi-feature-carousel-card">
      <div
        className="badget-title"
        style={{
          color: "white",
          backgroundColor: tool.heading_color,
        }}
      >
        {tool.label}
      </div>
      <img
        src={`${process.env.PUBLIC_URL}/images/${tool.bg_image}`}
        alt="Background Image"
      />
      <h3>{tool.heading}</h3>
      <p className="card-description">{tool.description}</p>
      <ul className="card-bullets-list">
        {tool.features.map((feature) => (
          <li key={feature} className="card-bullet-item">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/check_dark.svg`}
              className="faq-card-icon"
              alt={checkIconAlt}
            />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FiFeatureCarouselCard;
